<template>
	<div class='knd-custom-desktop-animation' >
    <svg viewBox="0 0 1215 61" fill="none" xmlns="http://www.w3.org/2000/svg">
      
      <path d="M0 56L1215 56" stroke="url(#paint0_linear_211_238)" stroke-width="0.5"/>

      <circle r="3" fill="white" id="p1">
          <animateMotion
            dur="25"
            fill="white"
            delay="5"
            repeatCount="indefinite"
            path="M0 56L1215 56" />
        </circle>


      <g filter="url(#filter1_d_211_238)">
        <path d="M333 13L730.263 13C737.19 13 742.805 18.6154 742.805 25.5423V25.5423C742.805 32.4692 748.421 38.0845 755.347 38.0845L843 38.0845" stroke="url(#paint1_linear_211_238)" stroke-width="0.5"/>
      </g>

      <circle r="3" fill="white" id="p1">
          <animateMotion
            dur="25"
            fill="white"
            delay="5"
            repeatCount="indefinite"
            path="M333 13L730.263 13C737.19 13 742.805 18.6154 742.805 25.5423V25.5423C742.805 32.4692 748.421 38.0845 755.347 38.0845L843 38.0845" />
        </circle>

      <defs>
      <linearGradient id="paint0_linear_211_238" x1="-374.468" y1="100" x2="-308.268" y2="407.177" gradientUnits="userSpaceOnUse">
      <stop offset="0.246044" stop-color="white"/>
      <stop offset="0.697204" stop-color="#EEEEEE"/>
      <stop offset="0.975208" stop-color="#575757"/>
      </linearGradient>
      <linearGradient id="paint1_linear_211_238" x1="460.5" y1="14" x2="855.266" y2="-139.839" gradientUnits="userSpaceOnUse">
      <stop stop-color="#575757"/>
      <stop offset="0.196521" stop-color="#E0E0E0"/>
      <stop offset="0.500855" stop-color="white"/>
      <stop offset="1" stop-color="#575757"/>
      </linearGradient>
      </defs>
      </svg>
	</div>
</template>

<script>

export default {
  props: [],
  setup () {

    return {
    }
  }
}
</script>


<style lang="scss">
.knd-custom-desktop-animation {
  position: absolute;
  width: 100%;
  top: 40%;
  left: 0;
  right: 0;

  display: none;

  @include md { 
    display: block;
  }

  svg {
    width: 100%;

    circle {
      box-shadow: 0px 0px 3px 1px #FFFFFF;
      filter: blur(1px);
    }
  }
}

</style>